import { put, call, all } from "redux-saga/effects";

import { BFFAgent } from '../../../../common/BFFAgent';
import {
  STOCK_DICTIONARY_DELETE_TRANSLATION_SUCCESS,
  STOCK_DICTIONARY_DELETE_TRANSLATION_FAILURE,
} from '../constants';

import { SuccessAction } from '../../../common/redux/toasts'

export function* deleteTranslationSaga(action) {
  try {
    yield call(BFFAgent.Stock.Dictionary.deleteDictionaryTranslation, action.data)

    yield all([
      put({type: STOCK_DICTIONARY_DELETE_TRANSLATION_SUCCESS}),
      put( SuccessAction({title:"¡Listo! El termino se elimino del diccionario."})),
  ]);
  
  } catch (error) {

    yield put({
      type: STOCK_DICTIONARY_DELETE_TRANSLATION_FAILURE,
      data: { error },
    })
  }

}
